import axiosInstance from "./axiosInstance";
import APIEndpoint from "./endpoint";

export const downloadFile = async (fileName) => {
  const api = APIEndpoint.DOWNLOAD_FILE_API + `?filePath=${fileName}`;
  const res = await axiosInstance.get(api);
  return res || false;
};

export const getListFileImport = async () => {
  const api = APIEndpoint.IMPORT_FILE_API;
  const res = await axiosInstance.get(api);

  return res;
};

export const getListTemplateImport = async () => {
  const api = APIEndpoint.IMPORT_TEMPLATE_API;
  const res = await axiosInstance.get(api);
 
  return res;
};
